import {
  getApiErrorMessage,
  isForbiddenError,
  isValidationError,
} from "@/utils/apiError";

type Translate = (key: string) => string;

export const getEditErrorMessage = (
  error: unknown,
  t: Translate,
  prefix: string,
): string => {
  if (isForbiddenError(error)) {
    return t(`${prefix}.forbidden`);
  }

  if (isValidationError(error)) {
    return t(`${prefix}.validationError`);
  }

  return getApiErrorMessage(error, t(`${prefix}.saveError`));
};
